module.exports = __webpack_public_path__ + "static/media/jason_choy.91217417.png";